/**
 * True when a request was cancelled through its caller's AbortSignal, rather
 * than failing. A cancel is neither a success nor a failure -- the caller no
 * longer wants the response -- so it must not be logged as an error, counted in
 * success/latency metrics, or retried.
 *
 * fetch rejects with a DOMException named AbortError, which is the only shape
 * left now that axios is gone (axios 1.x rejected with its own CanceledError).
 *
 * NOTE for callers reasoning about retries: fetchWithTimeout enforces its
 * deadline by aborting its own controller, so a TIMEOUT also rejects with an
 * AbortError and is indistinguishable here from a cancellation. `request` does
 * not use this predicate to make that decision -- it uses whether
 * fetchWithTimeout classified the failure at all. Use this only where the
 * question is "should I report this to the user", as the search bar does.
 */
const isAbortError = (error: unknown): boolean =>
  typeof error === 'object' &&
  error !== null &&
  (error as { name?: unknown }).name === 'AbortError';

export default isAbortError;
